import cx from 'classnames';
import { getOnlyChildrenString } from 'helpers/string.helper';
import React, { FC, HtmlHTMLAttributes } from 'react';
import { TYPOGRAPHY_COMPONENT, TYPOGRAPHY_VARIANTS } from './typography-utils';
import './typography.css';

export enum TypographyColor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export type Props = HtmlHTMLAttributes<HTMLParagraphElement> & {
  variant?: string;
  component?: string;
  normalCase?: boolean;
  upperCase?: boolean;
  firstCapCase?: boolean;
  color?: TypographyColor;
  isError?: boolean;
};

const Typography: FC<Props> = ({
  className,
  variant = TYPOGRAPHY_VARIANTS.BODY,
  normalCase = false,
  upperCase = false,
  firstCapCase = false,
  color = TypographyColor.PRIMARY,
  isError,
  ...rest
}) => (
  <DynamicComponent
    {...rest}
    data-text={getOnlyChildrenString(rest)}
    className={cx(
      'pb-typography',
      {
        'normal-case': normalCase,
        uppercase: upperCase,
        'pb-typography-firstCapCase': firstCapCase,
        'text-pb-h1': variant === TYPOGRAPHY_VARIANTS.H1,
        'text-pb-h2': variant === TYPOGRAPHY_VARIANTS.H2,
        'text-pb-body': variant === TYPOGRAPHY_VARIANTS.BODY,
        'text-pb-small': variant === TYPOGRAPHY_VARIANTS.SMALL,
        'text-pb-xs': variant === TYPOGRAPHY_VARIANTS.XS,
        'pb-typography-primary-color': color === TypographyColor.PRIMARY,
        'pb-typography-secondary-color': color === TypographyColor.SECONDARY,
        'pb-typography-error': isError,
      },
      className,
    )}
  />
);

const DynamicComponent: FC<Props> = ({
  component = TYPOGRAPHY_COMPONENT.DIV,
  children,
  ...rest
}) => React.createElement(component, rest, children);

export default Typography;
